import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Program from "./pages/Program";
import Hotel from "./pages/Hotel";
import Contact from "./pages/Contact";
import UpdateNotification from "./UpdateNotification"; // NB! Path
import { updateApp } from "./index";

function App({ setShowUpdateCallback }) {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    if (setShowUpdateCallback) {
      setShowUpdateCallback(() => setShowUpdate);
    }
  }, [setShowUpdateCallback]);

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/program" element={<Program />} />
        <Route path="/hotell" element={<Hotel />} />
        <Route path="/kontakt" element={<Contact />} />
      </Routes>
      {showUpdate && <UpdateNotification onUpdate={updateApp} />}
    </Router>
  );
}

export default App;

